import { defineComponent as _defineComponent } from 'vue'
import ProductSwatchThumbnail from './ProductSwatchThumbnail.vue';
import UiDropdown from '../../../../components/UiDropdown.vue';
import { computed, ref } from 'vue';
import { IProductSwatch } from '../../../../types/Product';


//When activeSwatchColor is not provided it becomes display only

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSwatches',
  props: {
    swatches: null,
    activeSwatchColor: null
  },
  emits: ["swatch-change"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'swatch-change', swatch: IProductSwatch): void;

}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	swatches: IProductSwatch[];
	activeSwatchColor?: string;
}





const featuredSwatchCount = 4;
const showSwatchDropdown = ref(false);

const featuredSwatches = computed(() => {
	return props.swatches.slice(0, featuredSwatchCount);
});

function changeSwatch(swatch: IProductSwatch) {
	emit('swatch-change', swatch);
}


return { __sfc: true,props, emit, featuredSwatchCount, showSwatchDropdown, featuredSwatches, changeSwatch, ProductSwatchThumbnail, UiDropdown }
}

})